// Shared helpers for the subbroker's own support tickets.
//
// Tickets raised from the "New Ticket" modal are recorded in localStorage
// (TicketModal.js writes them under MY_TICKETS_KEY). The bell in the topbar
// (Shell.js) reuses that record to surface RESOLVED tickets as notifications,
// so both surfaces agree on the same source of truth.
import axios from 'axios'
import { subbrokerTicketsURL } from './Urls'

export const MY_TICKETS_KEY = 'subbroker_tickets'
// Ids of resolved tickets the user has already acknowledged (opened the bell on).
// Anything resolved but NOT in this set is an unread notification.
export const SEEN_RESOLVED_KEY = 'subbroker_resolved_seen'

const readJSON = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key) || fallback) } catch (e) { return JSON.parse(fallback) }
}

export const loadMyTickets = () => readJSON(MY_TICKETS_KEY, '[]')

export const loadSeenResolved = () => readJSON(SEEN_RESOLVED_KEY, '[]')
export const saveSeenResolved = (ids) => {
  try { localStorage.setItem(SEEN_RESOLVED_KEY, JSON.stringify(Array.from(new Set(ids)).slice(0, 300))) } catch (e) { /* ignore */ }
}

// Same rule TicketModal uses for the "Resolved" badge.
export const isResolvedStatus = (s) => {
  const u = String(s || '').toUpperCase()
  return u === 'CLOSED' || u === 'RESOLVED'
}

// Fetch the live status of every ticket raised from here and return only the
// resolved ones (most-recent first). Network/auth failures degrade to []: the
// bell simply shows nothing rather than erroring.
export const fetchResolvedTickets = async () => {
  try {
    const response = await axios.get(subbrokerTicketsURL, { withCredentials: true })
    const tickets = response?.data?.tickets || []
    return tickets.filter((t) => isResolvedStatus(t.status))
  } catch (e) { return [] }
}
